import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { StoreService } from '../../../store/store.service';
import { Observable } from 'rxjs';
import { Store } from '../../../store/store';
import { Meta } from '@angular/platform-browser';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-store-preview',
  templateUrl: './store-preview.component.html',
  styleUrls: ['./store-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StorePreviewComponent implements OnInit {
  @Input() storeID = '';
  store$: Observable<Store> | undefined;

  constructor(
    private readonly storeService: StoreService,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    this.store$ = this.storeService
      .getOneByIdPublic(this.storeID)
      .pipe(tap((store) => this.setMeta(store)));
  }

  setMeta(store: Store): void {
    this.meta.updateTag({ name: 'author', content: store.name });
  }
}
